<template>
	<div class="add">
		<el-cascader
			ref="select"
			size="small"
			v-model="value.id"
			:options="predicateOptions"
			placeholder="Choose Condition"
			:props="{ expandTrigger: 'hover' }"
			@change="changed"
			:show-all-levels="showAllLevels"
			style="width:350px">
		</el-cascader>
		&nbsp;
		<template v-if="predicate && profiles">
			<span v-if="predicateSelect">
				<el-select
					size="small"
					style="width:450px"
					v-model="value.arg"
					filterable
					no-data-text="Loading options..."
					:placeholder="predicatePlaceholder"
					:multiple="true">
					<el-option v-for="option in predicateContentOptions"
						:key="value.id.join('-') + '-' + option.value"
						:value="option.value"
						:label="option.label">
						<span style="float: left">{{ option.label }}</span>
      					<span v-if="option.parent" style="float: right; color: #8492a6; font-size: 13px">
							{{ option.parent }}
						</span>
					</el-option>
				</el-select>
			</span>
			&nbsp;
			<!-- <el-dropdown placement="bottom-start">
				<el-button icon="el-icon-plus" circle
					size="small">
				</el-button>
			  <el-dropdown-menu slot="dropdown">
				<el-dropdown-item></el-dropdown-item>
				<el-dropdown-item> 2</el-dropdown-item>
				<el-dropdown-item>Action 3</el-dropdown-item>
				<el-dropdown-item disabled>Action 4</el-dropdown-item>
				<el-dropdown-item divided>Action 5</el-dropdown-item>
			  </el-dropdown-menu>
			</el-dropdown> -->
		</template>
		&nbsp;
		<el-button icon="el-icon-close"
			size="small"
			type="danger"
			plain circle
			@click="remove">
		</el-button>

	</div>
</template>
<script>
import Vue from 'vue'
import { mapActions, mapGetters } from 'vuex'
import predicates from '../predicate'
import predicateOptions from '../predicate/options'

export default {
	name: 'filter-predicate',

	props: ['value'],

	data() {
		return {
			// predicate: this.value,
			predicateOptions,
			currentGroup: null
		}
	},

	created() {
		if (this.provider) {
			let loadProfiles = this.provider.profile.filter((id) => this.getContent('profile', id) == null)
			if (loadProfiles.length > 0)
				this.loadContent({
					type: 'profile',
					id: loadProfiles
				})
		}
	},

	methods: {
		...mapActions('content', [
			'loadContent'
		]),
		changed() {
			Vue.set(this.value, 'arg', [])
			this.$emit('value', this.value)
			this.$emit('change')
		},
		remove() {
			this.$emit('remove')
		},
		profileKey(key) {
			if (this.profiles) {
				if (key == 'profile')
					return this.profiles.map((p) => p.id)
				return [].concat.apply([], this.profiles.map((profile) => profile[key]).filter((p) => p != null))
			}
		},
	},

	watch: {
		profiles(profileIds) {
			let loadProfiles = profileIds.filter((id) => this.getContent('profile', id) == null)
			if (loadProfiles.length > 0)
				this.loadContent({
					type: 'profile',
					id: loadProfiles
				})
		},
		predicateSelect(select) {
			if (select) {
				if (select.content) {
					let content = this.getContent(select.content)
					if (! content)
						this.loadContent({
							type: select.content,
							id: this.profileKey(select.content)
						})
				}
				else if (select.provider) {
					return this.provider.label.map((label) => ({

					}))
				}
			}
		}
	},

	computed: {
		...mapGetters('provider', [
			'getProvider'
		]),
		...mapGetters('content', [
			'getContent'
		]),
		provider() {
			return this.getProvider
		},
		profiles() {
			if (this.provider)
				return this.provider.profile
			return null
		},
		predicateGroup() {
			return predicates.find((predicate) => (predicate.option.value === this.value.id[0]))
		},
		/**
		 * @func predicate
		 * @desc Finds the predicate object from the predicate folder, somewhat convoluted logic required
		 */
		predicate() {
			let group = predicates.find((predicate) => (predicate.option.value === this.value.id[0]))
			if (group && group.option && group.option.children && this.value.id.length > 1)
				return group.option.children.find((child) => (child.value === this.value.id[1]))
			return null
		},
		showAllLevels() {
			return this.predicateGroup != null && this.predicateGroup.show === true
		},
		showSelect() {
			return this.predicate && this.predicate.select != null
		},
		predicateSelect() {
			if (this.predicate)
				return this.predicate.select
			return null
		},
		predicateContentType() {
			if (this.predicate && this.predicate.select)
				return this.predicate.select.content
			return null
		},
		predicateContentOptions() {
			if (this.predicateSelect) {
				if (this.predicateSelect.children)
					return this.predicateSelect.children
				if (this.predicateSelect.provider == 'label')
					return (this.provider.label || []).map((label) => ({
						id: label.id,
						value: label.id,
						label: label.title
					}))
			}

			if (this.predicateContentType)
				return this.profileKey(this.predicateContentType).map((id) => {
					let content = this.getContent(this.predicateContentType, id)
					if (content)
						return {
							value: id,
							label: content.title || content.name
						}
				})
				.filter((option) => option != null)
			return []
		},
		predicatePlaceholder() {
			if (this.predicateSelect)
				return 'Select '
			return null
		}
	}
}
</script>
